import { ButtonHTMLAttributes, HTMLAttributes } from "react";
import "./index.scss";

export interface ButtonComponentProps {
  onClick?: () => void;
  containerProps?: HTMLAttributes<HTMLDivElement>;
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  buttonLabel?: string | null;
  varient?: "submit" | "outline";
  style?: React.CSSProperties;
  template?: "desktop" | "tablet";
}

const ButtonComponent = (props: ButtonComponentProps) => {
  const {
    onClick,
    buttonLabel = "Submit",
    varient = "submit",
    buttonProps,
    containerProps,
    style,
    template,
  } = props;

  return (
    <div className="button-container" {...containerProps} style={{ ...style }}>
      <button
        className={`btn hover:red ${varient} ${template}`}
        onClick={onClick}
        {...buttonProps}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default ButtonComponent;
